import React from "react";
import { t } from "components/CentralDataMangement/translation/Translation";
import type { WeeklyData } from "../Annotations";
import TableTitle from "components/common/atoms/TableTitle";

interface LabelKeyPair {
  label: string;
  key: string;
}

interface WeeklyReportTableProps {
  rows: LabelKeyPair[];
  data: Record<string, WeeklyData>;
  tableTitle?: string;
  /**
   * Per-locale activity wording keyed by the follow-up key, as returned by the report API
   * (ReportsCommonService::getActivityLabels). Rows are keyed by the raw enum value, so without
   * this the table shows the English key. Falls back to t(label) when not supplied.
   */
  activityLabels?: Record<string, string>;
}

const WeeklyReportTable: React.FC<WeeklyReportTableProps> = ({
  rows,
  data,
  tableTitle,
  activityLabels
}) => {

  const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun', 'Total'];

  return (
    <>
      {tableTitle &&
        <TableTitle title={tableTitle} />
      }
      <table className="table table-bordered">
        <thead>
          <tr className="TableHeader">
            <th style={{ width: "25%" }}></th>
            {days.map((day) => (
              <th key={day} className="text-center">
                {t(day)}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map(({ label, key }) => (
            <tr key={key}>
              <td className="align-middle">{activityLabels?.[key] ?? t(label)}</td>
              {days.map((day) => (
                <td key={day} className="text-center align-middle">
                  {data?.[key]?.[day.toLowerCase() as keyof WeeklyData]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </>

  );
};

export default WeeklyReportTable;
